var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleClipHeaderUniqueViewsOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8029 16.1029C14.94 16.0343 15.1029 16 15.2914 16H17.6057C17.88 16 18.0171 16.1371 18.0171 16.4114V33.5886C18.0171 33.8629 17.88 34 17.6057 34H15.4457C15.1714 34 15.0343 33.8629 15.0343 33.5886V19.0086C15.0343 18.8886 14.9743 18.8457 14.8543 18.88L12.4629 19.5486C12.4286 19.5657 12.3857 19.5743 12.3343 19.5743C12.2314 19.5743 12.1457 19.54 12.0771 19.4714C12.0257 19.4029 12 19.3086 12 19.1886V17.6971C12 17.4914 12.1029 17.3371 12.3086 17.2343L14.8029 16.1029Z",
    fill: "#FF6B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1694 24.171C38.556 24.6505 37.98 25.2398 37.419 24.9854C36.2381 24.45 34.9403 24.026 33.5574 23.7354C33.7597 24.2608 33.8706 24.8317 33.8706 25.4284C33.8706 28.032 31.7599 30.1426 29.1563 30.1426C26.5527 30.1426 24.442 28.032 24.442 25.4284C24.442 24.8316 24.5529 24.2608 24.7551 23.7353C23.3722 24.0259 22.0743 24.4499 20.8934 24.9853C20.3324 25.2397 19.7564 24.6504 20.1431 24.1709C22.2642 21.54 25.5136 19.8569 29.1562 19.8569C32.7988 19.8569 36.0482 21.54 38.1694 24.171ZM29.1563 28.4284C30.8131 28.4284 32.1563 27.0852 32.1563 25.4284C32.1563 23.7715 30.8131 22.4284 29.1563 22.4284C27.4994 22.4284 26.1563 23.7715 26.1563 25.4284C26.1563 27.0852 27.4994 28.4284 29.1563 28.4284Z",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleClipHeaderUniqueViewsOrange);
export default __webpack_public_path__ + "static/media/singleClipHeaderUniqueViewsOrange.49c4b66e06827ab82c1a26cd2f62f275.svg";
export { ForwardRef as ReactComponent };